import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/readAxios';
const MyCity = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        setloading(true)
        // $("#searchType .dropdown").removeClass("dropdown")
        ReadAxios({ masterURL: `${process.env.REACT_APP_MAIN_URL}/masters/cityMaster/${props.value}`, bodyItems: { searchTerm: '' }, method: "post" })
            .then((result) => {
                setcontent(result.data.resultSet)
                // console.log(result.data.resultSet);
                setloading(false)
            })
    }, [])
    let handleSearch = (e, data) => {
        if (data.searchQuery) {
            setloading(true)
            let searchTerm = data.searchQuery
            ReadAxios({ masterURL: `${process.env.REACT_APP_MAIN_URL}/masters/cityMaster`, bodyItems: { searchTerm: searchTerm }, method: "post" })
                .then((result) => {
                    setcontent(result.data.resultSet)
                    setloading(false)
                })
        }
    }
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = object.cityCode
            temp.text = object.cityName
            temp.value = object.city_id
            return options[index] = temp
        })
    }
    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
        content.filter((item) => {
            if (data.value === item.city_id) {
                props.getCityInfo(item)
                // setdriverContact(item.driverContact)
                // setdriverLic(item.driverLicense)
                // console.log('>>>', item)
            }
        })
    }
    return (
        <Dropdown
            selection
            search
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            // id="searchType"
            error={props.error}
            onSearchChange={handleSearch}
            noResultsMessage="Search for Result"
            {...props}
        />
    )
}
export default MyCity